import { render } from "./Notifications.vue?vue&type=template&id=7eb5882c"
const script = {}

import "./Notifications.vue?vue&type=style&index=0&id=7eb5882c&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__